"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autokey = void 0;
// Generate an autokey to be used with react-themeable

var autokey = function autokey(func) {
  var autoKey = 1;
  return function () {
    for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
      names[_key] = arguments[_key];
    }
    return func.apply(null, [autoKey++].concat(names));
  };
};
exports.autokey = autokey;